export enum HeatingMediumEnum {
    Water = 1,
    Steam = 2,
    ThermalOil = 3,
}
